/*
  Tap feedback on touch screens (styles in tap-feedback.css).
  iOS Safari does not reliably show :active, and a quick tap is often over before anything is painted.
  So while a finger is down, the touched element and its parents get the class "is-pressed",
  and it stays at least 120ms so a short tap is still visible. Scrolling (moving more than 10px) cancels it.
*/
(function () {
  var MIN_VISIBLE = 120;
  var MIN_VISIBLE_CLOSE = 180; // close crosses: partly hidden under the finger, so a little longer

  function minVisible() {
    for (var i = 0; i < pressed.length; i++) {
      if (pressed[i].hasAttribute('data-tap-close')) return MIN_VISIBLE_CLOSE;
      // close cross of the Pandectes cookie preferences popup (inside its shadow DOM, so no data attribute)
      if (pressed[i].matches('button.close') && pressed[i].getRootNode().host) return MIN_VISIBLE_CLOSE;
    }
    return MIN_VISIBLE;
  }
  var pressed = [];
  var timer, startX, startY, startTime;

  function clear() {
    var released = pressed;
    for (var i = 0; i < released.length; i++) {
      released[i].classList.remove('is-pressed');
      released[i].classList.add('is-released');
    }
    pressed = [];
    // .is-released lets a button fade out with a CSS animation after the finger lifts
    setTimeout(function () {
      for (var i = 0; i < released.length; i++) released[i].classList.remove('is-released');
    }, 300);
  }

  document.addEventListener('touchstart', function (e) {
    clearTimeout(timer);
    clear();
    if (e.touches.length > 1) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    startTime = Date.now();
    // composedPath() also reaches into shadow DOM (the Pandectes cookie banner), where e.target is only the host
    var path = e.composedPath ? e.composedPath() : [];
    if (!path.length) for (var p = e.target; p; p = p.parentElement) path.push(p);
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el === document.body || el === document || el === window) break;
      if (el.nodeType !== 1) continue;
      el.classList.add('is-pressed');
      pressed.push(el);
    }
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!pressed.length) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) clear();
  }, { passive: true });

  document.addEventListener('touchend', function () {
    clearTimeout(timer);
    timer = setTimeout(clear, Math.max(0, minVisible() - (Date.now() - startTime)));
  }, { passive: true });

  // iOS snaps a tap that lands just next to a small button (like a 20px close cross) onto that button.
  // The touch then started on the element next to it, so the button never got "is-pressed" but still gets the click.
  // Give it the pressed state here, so that tap shows the same feedback.
  document.addEventListener('click', function (e) {
    if (Date.now() - startTime > 1000) return; // only clicks that come from a touch
    var target = e.target.closest && e.target.closest('a, button, [role="button"]');
    if (!target || target.classList.contains('is-pressed') || target.classList.contains('is-released')) return;
    target.classList.add('is-pressed');
    pressed.push(target);
    clearTimeout(timer);
    timer = setTimeout(clear, minVisible());
  }, true);

  document.addEventListener('touchcancel', clear, { passive: true });
  // Coming back with the back button can restore the page from cache with a pressed state still on it
  window.addEventListener('pageshow', clear);
})();
